import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

type ExportProps = {
  setExportFormat: (format: string) => void;
  report_type?: string;
  loading?: boolean;
  defaultFormat?: string;
};

const ExportAction = (props: ExportProps) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: any) => {
    if (props.loading) return;

    // 如果指定了 defaultFormat，直接使用该格式，不显示菜单
    if (props.defaultFormat) {
      props.setExportFormat(props.defaultFormat);
      return;
    }

    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChoice = (format: string) => {
    props.setExportFormat(format);
    handleClose();
  };

  return (
    <Fragment>
      <Tooltip arrow title={t("common.Download")}>
        <LoadingButton
          onClick={handleClick}
          loading={props.loading}
          sx={{
            display: "inline-flex",
            minWidth: "auto !important",
            padding: "8px 12px",
            textTransform: "none",
            backgroundColor: "transparent",
            borderRadius: "6px",
            "&:hover": { backgroundColor: "transparent" },
            alignItems: "center",

            // 只加这一段 → 图标文字透明
            "&.MuiLoadingButton-loading i, &.MuiLoadingButton-loading .MuiTypography-root": {
              opacity: 0.4,
            },

            // 只加这一段 → 转圈加深、加粗
            "& .MuiCircularProgress-root": {
              color: "#1A8CBB !important",
              strokeWidth: 3.5,
            },
          }}
        >
          <i
            className="icon iconfont icon-ic_download"
            style={{ cursor: "pointer", color: "rgb(117, 130, 138)" }}
          ></i>
          <Typography
            style={{
              fontSize: "14px",
              color: "rgb(117, 130, 138)",
              cursor: "pointer",
              marginLeft: "4px",
              marginTop: "-2px",
            }}
          >
            {t("common.Download")}
          </Typography>
        </LoadingButton>
      </Tooltip>

      <Menu
        open={Boolean(anchorEl) && !props.loading && !props.defaultFormat}
        anchorEl={anchorEl}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem onClick={() => handleChoice("xlsx")}>xlsx</MenuItem>
        <MenuItem onClick={() => handleChoice("csv")}>csv</MenuItem>
        {props.report_type === "timecard" && (
          <MenuItem onClick={() => handleChoice("xlsx with tz")}>xlsx with tz</MenuItem>
        )}
        {props.report_type === "timecard" && (
          <MenuItem onClick={() => handleChoice("csv with tz")}>csv with tz</MenuItem>
        )}
      </Menu>
    </Fragment>
  );
};

export default ExportAction;
